import { Modal, Text, ActionButton } from "components/commons";
import { useHistory } from "react-router-dom";
import locale from "localization";
import React from "react";
import styles from "./edit-wholesale-price-status-modal.module.scss";
import { Path } from "enums";

const EditWholesalePriceStatusModal = ({ data, success, close, active }) => {
  const history = useHistory();
  const message = success ? locale.youMayGoToWholesalePrice : locale.pleaseCheckUploadedFile;
  const title = success ? locale.wholesalePriceSuccessfullySaved : locale.editWholesalePricefailed;
  const buttonMessage = success ? locale.goToWholesalePrice : locale.goBackToEditWholesalePrice;
  const forwardTo = Path.WholesalePrice;

  return (
    <Modal active={active} title={title} close={close} className={styles.modal}>
      <div className={styles.content}>
        <Text className={styles.message} align="center">
          {message}
        </Text>
      </div>
      <ActionButton
        primary
        className={styles.primary}
        center
        items={[
          {
            onClick: () => {
              success ? history.push(forwardTo) : close();
            },
            text: buttonMessage,
            primary: true,
          },
        ]}
      />
    </Modal>
  );
};

export default EditWholesalePriceStatusModal;
